import styled from "styled-components";

const StyledTable = styled.table<{ fullWidth?: boolean; spacing?: number }>`
  border-radius: 10px;
  border-collapse: collapse;
  border-style: hidden;
  width: ${(props) => (props.fullWidth ? "100%" : "")};
  box-shadow: 0 0 0 1px ${(props) => props.theme.palette.neutral4};
  border-spacing: 0;
  margin: ${({ spacing }) => (spacing ? spacing * 8 : 0)}px 0px;
`;

export default StyledTable;
